// @flow

import {HorizontalPositionElement, VerticalPositionElement} from './constants';

export type HorizontalPositionElementType = $Keys<typeof HorizontalPositionElement>;
export type VerticalPositionElementType = $Keys<typeof VerticalPositionElement>;

/**
* An object that contains the state of an overturned container.
*/
export type Flipped = {|
    height: boolean,
    width: boolean,
|};

/**
* Coordinates of the container in the DOM.
*/
export type CoordinatesBox = {|
    top: number,
    left: number,
|};

/**
* Coordinates of the anchor in the DOM.
*/
export type AnchorPosition = {|
    top: number,
    left: number,
|};

/**
* The component used for the transition.
*/
export type BoxPosition = {|
    vertical: number,
    horizontal: number,
|};

/**
* The component used for the transition and its coordinates in space.
*/
export type TransformOrigin = {|
    horizontal: HorizontalPositionElementType,
    vertical: VerticalPositionElementType,
|};

/**
* This is the point on the anchor.
 @deprecated It will be removed in 6 months 04-28-2026. Use Floating instead.
*/
export type CoordinatesType = {|
    top: number,
    left: number,
    bottom: number,
    right: number,
|};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./constants");
